import React from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';

export const getIsInConfluenceHoldoutData = (): {
	holdout: string;
} => {
	// This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
	const isInConfluenceHoldout =
		FeatureGates.initializeCompleted() &&
		!FeatureGates.checkGate('product-confluence-holdout-observability-gate', {
			fireGateExposure: false,
		});

	return {
		holdout: isInConfluenceHoldout ? 'confluence-holdout' : '',
	};
};

export const ConfluenceHoldoutCustomData = (): React.JSX.Element | null => {
	return <UFOCustomData data={getIsInConfluenceHoldoutData()} />;
};
